import React from "react"
import { MdOutlineSpaceDashboard } from "react-icons/md"
import MI_Ext from "./_ext"

class MI_task extends MI_Ext {
  renderIcon = () => {
    return <MdOutlineSpaceDashboard />
  }
}
export default MI_task
